"use strict";

(function() {

	// all accessible tables (tables that include <th>) get a uniform styling
	// TODO: detect number-only columns, and right-align (or even comma-align?)
	// NOTE: using :has() in a queryselector on a browser that doesn't support it, breaks the whole routine!

	let elms, e;
	// table:has(th) /* tables containing a <th> are assumed to be proper data tables */
	elms = Array.from(document.querySelectorAll("table")).filter(t => t.querySelector("th"));
	if (elms.length > 0) {
		loadCss("/assets/css/table.css");
	}

	/* don't run DOM editing code in editing mode, or else the modified elements will be stored */
	/* (or just for speeding up the editing interface where we don't need lots of the interactivity) */
	if (!(document.querySelector("body").classList.contains("isEditing"))) {

		// add additional properties for responsive tables (add header text on every cell)
		// thead, tr:first-child:not(:has(td))
		elms = [
			...document.querySelectorAll("thead"),
			...[...document.querySelectorAll("tr")].filter(tr => tr.parentElement.firstElementChild === tr && !tr.querySelector("td"))
		]
		elms.forEach(thead => {
			// document.querySelectorAll("table:has(thead, tr:first-child:not(:has(td)))") gives an error, so have to use `nearest` to get the table
			const hdrcells = thead.querySelectorAll("th, td");
			thead.parentElement.querySelectorAll("tbody tr").forEach(tr => {
				tr.querySelectorAll(":is(td,th)").forEach((td,i) => {
					if (i > 0) /* can we always safely remove the header for the first column? note that first header is not always a column header, I've also seen it as a header for the whole header row */
						td.dataset.header = hdrcells[i].innerText; /* add data-header attribute for mobile layout */
				})
			})
		})

		// perform checks on window resize (check table width)
		const resizeObserver = new ResizeObserver(entries => {
			for (const entry of entries) {
				// adding requestAnimationFrame() is not needed for site, but not having it causes "ResizeObserver loop completed with undelivered notifications" in Cypress
				requestAnimationFrame(() => {
					// add .too-wide attribute to tables that are too wide to be completely displayed; they need mobile layout
					for (const table of Array.from(entry.target.querySelectorAll("table")).filter(t => t.querySelector("th")) /* = table:has(th) */) {
						const container = table.parentElement;
						container.style.overflowX = "hidden";
						const containerComputedStyle = getComputedStyle(container);
						const containerInnerWidth = container.clientWidth - parseFloat(containerComputedStyle.paddingLeft) - parseFloat(containerComputedStyle.paddingRight)
						if (table.clientWidth > containerInnerWidth) {
							if (!table.classList.contains("too-wide")) {
								table.dataset.minwidth = table.clientWidth;
								table.classList.add("too-wide");
							}
						} else if (containerInnerWidth >= table.dataset.minwidth) {
							table.classList.remove("too-wide");
						}
						container.style.overflowX = null;
					}
				})
			}
		})

		if (document.querySelector("#main").querySelector("th")) {
			resizeObserver.observe(document.querySelector("#main"));
		}
	}

})();
